export enum ErrorCode {
  NOT_FOUND_STAFF = "スタッフが見つかりません。",
  DUPLICATE_STAFF_EMAIL = "入力されたメールアドレスはすでに登録済みです。",
  DUPLICATE_COMPANY_NAME = "入力された会社名はすでに登録済みです。",
  TIMEOUT = "接続がタイムアウトになりました。お使いのインターネット回線の状況をご確認のうえ再度アクセスお願いします。",
  UNAUTHORIZED = "認証エラーです。再度ログインをしてください。",
  BAD_REQUEST = "不正なリクエストです",
}
